import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  url = environment.apiUrl;
  constructor(private httpClient: HttpClient) { }

  subscribeForNews(data) {
    return this.httpClient.post(environment.apiUrl + '/main/subscribe-for-news', data);
  }

}
